import { useDispatch, useReduxState } from 'hooks';
import Router from 'next/router';
import api from 'api';
import { actions } from 'store';
import { ModalButtonWithForm } from 'components/common';
import { FormGroup, Text } from 'components/common/form';

interface Props {
  disabled?: boolean;
}

const AddChapter = ({ disabled = false }: Props) => {
  const { dispatch } = useDispatch();

  const {
    messages,
    pageState: { course, newChapter }
  } = useReduxState();

  const submit = async (values) => {
    try {
      const chapter = await api.post(
        `/admin/courses/${course.id}/chapters`,
        values
      );

      dispatch(
        actions.addNotice({
          text: messages.editChapterCreated,
          type: 'success'
        })
      );

      Router.push(
        '/admin/courses/[courseSlug]/edit/[chapterSlug]',
        `/admin/courses/${course.slug}/edit/${chapter.data.chapter.slug}`
      );
    } catch (err) {
      await dispatch.handleErrorDispatch(err);
    }
  };

  const validateTitle = (value: string) => {
    return !value
      ? messages.editChapterTitleEmpty
      : value.length > 255
      ? messages.commonTextTooLong
      : undefined;
  };

  return (
    <ModalButtonWithForm
      buttonCategory="success"
      buttonDisabled={disabled}
      buttonIcon="plus"
      buttonText={messages.editAddChapter}
      modalActionText={messages.commonAdd}
      modalTitle={messages.editAddChapter}
      modalVisibleDefault={newChapter}
      onSubmit={submit}
      pristineIsValid={false}
    >
      {() => (
        <FormGroup htmlFor="chapter-title" label={messages.editChapterTitle}>
          <Text
            field="title"
            id="chapter-title"
            validate={validateTitle}
            validateOnChange={true}
          />
        </FormGroup>
      )}
    </ModalButtonWithForm>
  );
};

export default AddChapter;
